// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { formatText, FormattedText } = require('core/i18n').i18n;

// @components
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');

// @constants
const { getTranslatedCountry } = require('constants/countries');
const TAXING_REASON = require('constants/taxingReason');

// @utilities
const { PROC_OPEN_YOUNG_FISCAL_DATA } = require('utilities/tagging');

class OpenYoungFiscalDataSuccess extends React.Component {

    buildListCountriesWithAdditionalTaxing() {
        const {immOpenYoungTaxData} = this.props;
        let content;
        
        const listCountriesAdditionalTaxing = immOpenYoungTaxData.get('byId');
        if (!listCountriesAdditionalTaxing || (listCountriesAdditionalTaxing.size === 0 )) {
            content = <FormattedText className="open-young-fiscal-data-view__text-additional-tributation" value="profile-taxInformation_noAdditionalTributation"/>;
        } else {
            content = [];
            listCountriesAdditionalTaxing.forEach((immCountry, index) => {
                const country = getTranslatedCountry(immCountry.getIn(['country', 'value']));
                const taxingReason = TAXING_REASON[immCountry.getIn(['reason', 'value'])];
                const tin = immCountry.getIn(['tin', 'value']);
                content.push(
                    <div className="open-young-fiscal-data-view__text-additional-tributation" key={index}>
                        {`${country}, ${taxingReason}. TIN: ${tin}`}
                    </div>
                );
            });
        }
        return content;
    }

    render() {
        const goBackButton = {
            label: (
                <FormattedText
                    format="uppercase"
                    value="openYoungFiscalData-openYoungFiscalData_successBackButtonText"
                />
            ),
            url: `/myprofile/edit`
        };

        return (
            <WizardSuccess
                mainButton={goBackButton}
                processType={PROC_OPEN_YOUNG_FISCAL_DATA}
                successMessage={formatText('openYoungFiscalData-openYoungFiscalData_successTitle')}
            >
                <OKInformativeList columns={1}>
                    <OKInformativeListItem
                        title={formatText('openYoungProfileDetails-openYoungProfileDetails_otherCountries')}
                        onlyChildren
                    >
                        {this.buildListCountriesWithAdditionalTaxing()}
                    </OKInformativeListItem>
                </OKInformativeList>
            </WizardSuccess>
        );
    }
}

OpenYoungFiscalDataSuccess.propTypes = {
    immOpenYoungTaxData: PropTypes.object.isRequired,
};

module.exports = OpenYoungFiscalDataSuccess;
